module.exports = __webpack_public_path__ + "static/warning-icon-3f678344e57905be62d794a9d5270a1c.jpg";